import { Skeleton } from 'antd';

export const renderSkeleton = (taskId?: string) => {
  return [
    {
      key: taskId ?? '0',
      label: <Skeleton.Input active={true} size={'small'} />,
      disabled: true,
      children: (
        <div className='flex gap-1'>
          <Skeleton.Input active={true} size={'small'} />
          <Skeleton.Input active={true} size={'small'} />
        </div>
      ),
    },
    {
      key: '1',
      label: <Skeleton.Input active={true} size={'small'} />,
      disabled: true,
    },
  ];
};
